import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import axios from "axios";
import socket from "../socket"; 
import { endpoints } from "../services/operations/api"; 
import "./Dashboard.css"; 

function Dashboard() {
  const profileLoading = useSelector((state) => state.profile?.loading) || false;
  const authLoading = useSelector((state) => state.auth?.loading) || false;
  const [events, setEvents] = useState([]);

  useEffect(() => {
    
    const fetchEvents = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token")); 
        const response = await axios.get(endpoints.GET_ALL_EVENTS_API, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data.success) {
          setEvents(response.data.events);
        } else {
          console.error("Failed to fetch events:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching events:", error.response?.data?.message || error.message);
      }
    };

    fetchEvents();

   
    socket.on("attendeeCountUpdated", ({ eventId, attendeeCount }) => {
      setEvents((prevEvents) =>
        prevEvents.map((event) =>
          event._id === eventId ? { ...event, attendeeCount } : event
        )
      );
    });

    return () => {
      socket.off("attendeeCountUpdated");
    };
  }, []);

  
  const handleJoinEvent = async (eventId) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        endpoints.ATTEND_EVENT_API(eventId),
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.success) {
      
        socket.emit("updateAttendees", { eventId, attendeeCount: response.data.attendeeCount });
      } else {
        console.error("Failed to join event:", response.data.message);
      }
    } catch (error) {
      console.error("Error joining event:", error.response?.data?.message || error.message);
    }
  };

  if (profileLoading || authLoading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-content">
        <div className="dashboard-header">
          <h1 className="dashboard-title">Dashboard</h1>
          <div className="dashboard-actions">
            <Link to="/create-event" className="button create-event-button">
              Create New Event
            </Link>
            <Link to="/real-time-attendees" className="button event-list-button">
              Event-List
            </Link>
          </div>
        </div>
        <div className="events-section">
          <h2 className="section-title">Events</h2>
          {events.length > 0 ? (
            <ul className="events-list">
              {events.map((event) => (
                <li key={event._id} className="event-item">
                  <Link to={`/event/${event._id}`} className="event-link">
                    <span className="event-name">{event.name}</span>
                    <span className="event-date">
                      {new Date(event.date).toLocaleDateString()}
                    </span>
                    <span className="event-location">{event.location}</span>
                    <span className="event-attendees">{`Attendees: ${event.attendeeCount}/${event.maxAttendees}`}</span>
                  </Link>
                </li>
              ))}
            </ul>
          ) : (
            <p className="no-events">No events found.</p>
          )}
        </div>
      </div>
    </div>
  
  );
}

export default Dashboard;
